var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "black",
    strokeOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7046 8.99961C11.7159 8.44744 12.1728 7.99982 12.7251 7.99982C13.2774 7.99982 13.7159 8.44744 13.7046 8.99961C13.6933 9.55178 13.2364 9.9994 12.6842 9.9994C12.1319 9.9994 11.6933 9.55178 11.7046 8.99961ZM17.0269 17.6778L16.33 15.0883C16.1597 14.4427 15.5786 13.9976 14.9073 13.9986H13.6023L13.633 12.4989C13.9846 12.8147 14.4404 12.9921 14.9177 12.9988H15.8627C16.0008 12.9988 16.115 12.8869 16.1179 12.7488L16.1281 12.2489C16.1309 12.1109 16.0213 11.999 15.8832 11.999H14.9382C14.6019 11.9989 14.2916 11.8299 14.1124 11.5491L13.7297 10.9492C13.5505 10.6684 13.2402 10.4993 12.9039 10.4993H12.6739C12.1216 10.4993 11.6648 10.9469 11.6534 11.4991L11.5972 14.2485C11.5887 14.6626 11.9176 14.9983 12.3318 14.9983H14.6968C15.0328 14.9984 15.3238 15.2205 15.4106 15.5432L16.0241 17.8178C16.053 17.9244 16.1493 17.9977 16.2604 17.9977H16.7604C16.8985 17.9977 17.0127 17.8858 17.0155 17.7478C17.0214 17.7248 17.0252 17.7014 17.0269 17.6778ZM11.7133 16.9922C12.4734 16.9045 13.0581 16.2615 13.0716 15.4983H14.0716C14.0444 16.8135 13.0023 17.9036 11.6878 17.9916C10.3734 18.0797 9.23649 17.1356 9.0872 15.8321C8.93791 14.5286 9.82735 13.3118 11.1217 13.0488L11.1004 14.0886C10.3755 14.343 9.94627 15.0972 10.1032 15.8407C10.2602 16.5842 10.9532 17.0799 11.7133 16.9922Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Disabled.f97dd55e.svg";
export { ForwardRef as ReactComponent };